<template lang="html">
  <boxwrap class="admin-list--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <button
          class="btn--create"
          title="생성"
        >
          <label>
            <input
              type="file"
              style="display: none;"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="handleSelectFile"
              multiple
            >
            select file
          </label>
        </button>

        <button
          v-if="list.length"
          :disabled="isDataLoading"
          class="btn--modify"
          @click="importCSV"
        >
          <label>
            import
          </label>
        </button>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{ 'data-loading': showDataLoading }"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      />

      <tbl
        :scrollable="true"
        v-else
      >
       <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="no">
                no
              </tbl-td>

              <tbl-td name="created_at">
                created
              </tbl-td>

              <tbl-td name="login_id">
                login id
              </tbl-td>

              <tbl-td name="login_name">
                login name
              </tbl-td>

              <tbl-td name="agent_name">
                agent
              </tbl-td>

              <!-- <tbl-td name="code_name">
                code
              </tbl-td> -->

              <tbl-td name="bank_name">
                bank name
              </tbl-td>

              <tbl-td name="bank_account">
                bank account
              </tbl-td>

              <tbl-td name="bank_number">
                bank number
              </tbl-td>

              <tbl-td name="level">
                level
              </tbl-td>

              <tbl-td name="status">
                status
              </tbl-td>

              <tbl-td name="updated_at">
                updated
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(userValue, valueKey) in list"
              :key="valueKey"
            >
              <tbl-td name="no">
                {{ valueKey + 1 }}
              </tbl-td>

              <tbl-td name="created_at">
                -
              </tbl-td>

              <tbl-td name="login_id">
                {{ userValue.login_id }}
              </tbl-td>

              <tbl-td name="login_name">
                {{ userValue.login_name }}
              </tbl-td>

              <tbl-td name="agent_name">
                {{ userValue.agent && userValue.agent.agent_name || '-' }}
              </tbl-td>

              <!-- <tbl-td name="code_name">
                code
              </tbl-td> -->

              <tbl-td name="bank_name">
                {{ userValue.userWallets && userValue.userWallets.bank_name || '-' }}
              </tbl-td>

              <tbl-td name="bank_account">
                {{ userValue.userWallets && userValue.userWallets.bank_account || '-' }}
              </tbl-td>

              <tbl-td name="bank_number">
                {{ userValue.userWallets && userValue.userWallets.bank_number || '-' }}
              </tbl-td>

              <tbl-td name="level">
                Lv.{{ userValue.level }}
              </tbl-td>

              <tbl-td name="status">
                {{ userStatus(userValue.status) }}
              </tbl-td>

              <tbl-td name="updated_at">
                {{ userValue.updated_at || '-' }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <!-- <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          /> -->
        </tbl-footer>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapActions } from 'vuex'

// components
import CheckDataList from '@/components/base/CheckDataList'

// mixins
import { swal } from '@/assets/js/mixins/base/Swal'

// lib
import xlsx from 'xlsx'
import _get from 'lodash/get'
import _head from 'lodash/head'
import _size from 'lodash/size'
import _camelCase from 'lodash/camelCase'

const getStatus = (key, object) => object[key] || key

export default {
  name: 'Import',

  data () {
    return {
      isDataLoading: true,
      isEmpty: true,
      showDataLoading: true,

      list: [],
      import: {
        agent: [],
        user: [],
        code: [],
        agentWallets: [],
        userWallets: []
      }
    }
  },

  watch: {
    import: {
      deep: true,
      handler (object) {
        const users = _get(object, 'user')

        if (!users.length) return

        const agents = _get(object, 'agent')
        const userWallets = _get(object, 'userWallets')
        const list = []

        for (const user of users) {
          user.agent = agents.find(e => e.agent_id === user.code_id)
          user.userWallets = userWallets.find(e => e.login_id === user.login_id)

          list.push(user)
        }

        this.list = list
      }
    }
  },

  components: {
    CheckDataList
  },

  mixins: [
    swal
  ],

  mounted () {},

  methods: {
    _size,
    ...mapActions('import-csv', { publishCSV: 'createCSV' }),

    userStatus (status) {
      return getStatus(status, {
        C: 'Confirm',
        B: 'Banned',
        D: 'Deleted'
      })
    },

    async handleSelectFile (xml) {
      this.isDataLoading = true
      this.showDataLoading = true
      this.isEmpty = false

      const files = _get(xml, 'target.files')

      if (!files && !files.length) {
        this.isDataLoading = false
        this.showDataLoading = false
        this.isEmpty = true
        return console.warn('No selected file.')
      }

      for (const file of files) {
        const fn = _head(file.name.split('.'))

        const reader = new FileReader()
        reader.onload = async e => {
          const data = e.target.result
          const workbook = xlsx.read(data, { type: 'binary' })
          const wsname = _head(workbook.SheetNames)
          const worksheet = workbook.Sheets[wsname]
          const json = xlsx.utils.sheet_to_json(worksheet, { header: 2 })

          for (let i = 0; i < json.length; i++) {
            this.import[_camelCase(fn)].push(json[i])
          }
        }

        reader.readAsBinaryString(file)
      }

      xml.target.value = []

      this.isDataLoading = false
      this.isEmpty = false
      this.showDataLoading = false
    },

    importCSV () {
      const success = async () => {
        this.isDataLoading = true
        this.showDataLoading = true

        const importStatus = await this.publishCSV({
          list: this.list,
          ...this.import
        })

        this.list = []
        this.import.agent = []
        this.import.user = []
        this.import.userWallets = []
        this.import.agentWallets = []

        this.isEmpty = true
        this.isDataLoading = false
        this.showDataLoading = false

        if (importStatus === 200) {
          this.$alert('success', 'Imported Success', '', '', '')
        } else {
          this.$alert('error', 'The cause of the error is invalid column or duplicate entry', '', '', 'error')
        }
      }

      this.$alert('prompt', 'are you sure do want to import this?', {}, { success }, 'question')
    }
  }
}
</script>
